export const getEnvironment = () => {
  const vercelEnv = process.env.VERCEL_ENV || process.env.NEXT_PUBLIC_VERCEL_ENV

  const localEnv =
    process.env.NODE_ENV === 'production' ? 'local' : process.env.NODE_ENV

  return vercelEnv || localEnv || 'development'
}
